import FileTransferService from '~/sqlite/services/fileTransfer';
import { getFileNameFromUrl } from '~/user/helpers';

export const isAttachmentImage = (mimeType: string): boolean => {
    return !!mimeType && mimeType.toLowerCase().startsWith('image/');
};

export const getFileExtension = (fileName: string): string => {
    const parts = fileName.split('.');
    if (parts.length < 2) {
        return '';
    }
    return parts[parts.length - 1].toLowerCase();
};

export const isAllowedAttachment = (fileName: string, allowedFileExtensions: string[]): boolean => {
    if (!allowedFileExtensions || allowedFileExtensions.length === 0) {
        return true;
    }
    const extension = getFileExtension(fileName);
    return allowedFileExtensions.includes(extension);
};

const downloadInBrowser = async (url: string, fileName?: string) => {
    const name = fileName || getFileNameFromUrl(url) || 'attachment';
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
    } catch {
        window.open(url, '_blank');
    }
};

export const downloadAttachment = async (
    url: string,
    fileName?: string,
    mimeType?: string
): Promise<void> => {
    if (!url) {
        throw new Error('Missing download url');
    }

    if (window['cordova']) {
        const fileTransfer = new FileTransferService();
        await fileTransfer.downloadToDeviceStorage(url, {
            fileName,
            mimeType,
        });
        return;
    }

    await downloadInBrowser(url, fileName);
};
